import { Component, Input, OnInit } from "@angular/core";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { PlayerDto, PlayerSettingsDto } from "app/models";
import { NotificationService } from "app/services";
import { CONSTANTS } from '../../../constants';

@Component({
    selector: 'player-settings-modal',
    templateUrl: './player-settings.modal.html',
    styleUrls: ['./player-settings.modal.scss'],
})
export class PlayerSettingsModal implements OnInit {
    @Input() playerSettings: PlayerSettingsDto; 

    @Input() playerName: string;

    @Input() isGk: boolean;

    @Input() opponent: PlayerDto[];
    
    passLookup: any[];
    variant3Lookup: any[];
    variant2Lookup: any[];
    variant2AltLookup: any[];

    const;

    constructor(public activeModal: NgbActiveModal, private notificationService: NotificationService) {
        this.const = CONSTANTS;
    }

    ngOnInit(): void {
        this.buildLookups();
     }

 
    onSubmit() {
        if (this.isModelValid()) {
            this.activeModal.close(null);
        }
    }

    isModelValid(): boolean {


        return true;
    }

    getCurrentPassLabel(): string {
        let passType = this.passLookup.find(item => item.val === this.playerSettings.passType);

        return passType? passType.name : "Не выбран";
    }

    attackHelpSelected(val: number) {
        return this.playerSettings.attackHelp === val;
    }

    defenceHelpSelected(val: number) {
        return this.playerSettings.defenceHelp === val;
    }

    longShotSelected(val: number) {
        return this.playerSettings.longShots === val;
    }

    dribblingSelected(val: number) {
        return this.playerSettings.dribbling === val;
    }

    cutPassSelected(val: number) {
        return this.playerSettings.cutPass === val;
    }

    offsideSelected(val: number) {
        return this.playerSettings.offside === val;
    }

    standardAttackSelected(val: number) {
        return this.playerSettings.standardAtttack === val;
    }

    standardDefenceSelected(val: number) {
        return this.playerSettings.standardDefence === val;
    }

    freeRoleSelected(val: number) {
        return this.playerSettings.freeRole === val;
    }

    selectPass(val: number) {
        this.playerSettings.passType = val;
    }

    changeHelpAttack(val: number) {
        this.playerSettings.attackHelp = val;
    }

    changeHelpDefence(val: number) {
        this.playerSettings.defenceHelp = val;
    }

    changeLongShot(val: number) {
        this.playerSettings.longShots = val;
    }

    changeDribbling(val: number) {
        this.playerSettings.dribbling = val;
    }

    changeCutPass(val: number) {
        this.playerSettings.cutPass = val;
    }

    changeOffside(val: number) {
        this.playerSettings.offside = val;
    }

    changeStandardAttack(val: number) {
        this.playerSettings.standardAtttack = val;
    }

    changeStandardDefence(val: number) {
        this.playerSettings.standardDefence = val;
    }

    changeFreeRole(val: number) {
        this.playerSettings.freeRole = val;
    }

    getMarkPlayerName() {
        if (!this.opponent)
            return null;
        
        let result = "Никого";

        this.opponent.forEach(element => {
            if (this.playerSettings.markPlayerId == element.id) {
                result = element.name + " " + element.surname;
            }
        });

        return result;
    }

    selectMarkPlayer(val: number) {
        this.playerSettings.markPlayerId = val;
    }

    private buildLookups() {
        this.passLookup = [];
        this.passLookup.push( { val: CONSTANTS.playerSettings.passTypes.team, name: CONSTANTS.playerSettings.passLabels.team});
        this.passLookup.push( { val: CONSTANTS.playerSettings.passTypes.short, name: CONSTANTS.playerSettings.passLabels.short});
        this.passLookup.push( { val: CONSTANTS.playerSettings.passTypes.middle, name: CONSTANTS.playerSettings.passLabels.middle});
        this.passLookup.push( { val: CONSTANTS.playerSettings.passTypes.long, name: CONSTANTS.playerSettings.passLabels.long});

        this.variant3Lookup = [];
        this.variant3Lookup.push( { val: CONSTANTS.playerSettings.variant3.rare, name: CONSTANTS.playerSettings.variant3Labels.rare});
        this.variant3Lookup.push( { val: CONSTANTS.playerSettings.variant3.sometimes, name: CONSTANTS.playerSettings.variant3Labels.sometimes});
        this.variant3Lookup.push( { val: CONSTANTS.playerSettings.variant3.often, name: CONSTANTS.playerSettings.variant3Labels.often});

        this.variant2Lookup = [];
        this.variant2Lookup.push( { val: CONSTANTS.playerSettings.variant2.yes, name: CONSTANTS.playerSettings.variant2Labels.yes});
        this.variant2Lookup.push( { val: CONSTANTS.playerSettings.variant2.no, name: CONSTANTS.playerSettings.variant2Labels.no});

        this.variant2AltLookup = [];
        this.variant2AltLookup.push( { val: CONSTANTS.playerSettings.variant2.yes - 1, name: CONSTANTS.playerSettings.variant2Labels.yes});
        this.variant2AltLookup.push( { val: CONSTANTS.playerSettings.variant2.no - 1, name: CONSTANTS.playerSettings.variant2Labels.no});
    }

    
}